// middleware
import { changeVehicleConfiguration } from '../activities/change-vehicle';
import { openDealConfiguration } from '../activities/open-deal-dashboard';
import { navigationMiddleware } from '../middleware/navigationMiddleware';
import { toggleStatsMiddleware } from '../middleware/toggleStatsMiddleware';

export const getRemainingMiddleware = () => {
    return [navigationMiddleware, toggleStatsMiddleware, openDealConfiguration.middleware, changeVehicleConfiguration.middleware];
};
